"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ApiVersionNotFoundController", {
    enumerable: true,
    get: function() {
        return ApiVersionNotFoundController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const V1_PATH_PREFIX = '/api/v1/*';
const V2_PATH_PREFIX = '/api/v2/*';
const NOT_FOUND_PATH_PREFIX = '/api/v:apiVersion(\\d+)/*';
let ApiVersionNotFoundController = class ApiVersionNotFoundController {
    async apiVersion1And2NotFound(req) {
        _catchError.NcError.notFound(`Cannot ${req.method} ${req.path}`);
    }
    async apiVersionNotFound() {
        return {
            error: 'INVALID_API_VERSION',
            message: `API version unsupported`
        };
    }
};
_ts_decorate([
    (0, _common.All)([
        V1_PATH_PREFIX,
        V2_PATH_PREFIX
    ]),
    (0, _common.HttpCode)(404),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiVersionNotFoundController.prototype, "apiVersion1And2NotFound", null);
_ts_decorate([
    (0, _common.All)(NOT_FOUND_PATH_PREFIX),
    (0, _common.HttpCode)(404),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], ApiVersionNotFoundController.prototype, "apiVersionNotFound", null);
ApiVersionNotFoundController = _ts_decorate([
    (0, _common.Controller)()
], ApiVersionNotFoundController);
